import {ref} from 'vue';

/**
 * Whether a competition question dialog is on screen. The docked nudge waits
 * while it is: two interruptions at once read as a pile-up (27 Sep 2026).
 *
 * Only ever set in the browser (the dialog opens client side), so a module
 * ref is safe; on the server it stays false.
 */
export const competitionQuestionsOpen = ref(false);
